import { Flex } from "@chakra-ui/react";

export default function IconBackground({
  size = "48px",
  bg = "primaryLight",
  ...rest
} = {}) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      bg={bg}
      borderRadius="100%"
      width={size}
      height={size}
      {...rest}
    />
  );
}
